import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/LoginPage.css";
import logo from "/assets/logo.svg";

const ForgotPasswordSuccess = () => {
  const navigate = useNavigate(); // Initialize navigate

  useEffect(() => {
    // Check if the user came from the password reset page
    const passwordReset = sessionStorage.getItem("passwordReset");
    if (passwordReset !== "true") {
      // If not, redirect to the password reset page
      navigate("/forgotpassword/success");
    } else {
      // Clear the flag so the user can't refresh and stay on this page
      sessionStorage.removeItem("passwordReset");
    }
  }, [navigate]);

  const handleLoginClick = () => {

    navigate("/login"); // Use navigate to go to the /login route
  };

  return (
    <div className="background-image">
      <div className="container">
        <form className="login-form">
          <div className="logo">
            <img src={logo} alt="Logo" style={{ marginRight: "8px" }} />
          </div>

          <div className="password-changed">
            <h2>เปลี่ยนรหัสผ่านใหม่สำเร็จ</h2>
            <p>เข้าสู่ระบบใหม่อีกครั้ง</p>
            <button className="ok-branch" onClick={handleLoginClick}>
              ตกลง
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordSuccess;
